// ─────────────────────────────────────────────────────────────────────────
// SYSTEM PAGE  (Auto Trading → System tab)
//
// Operations console for the quant compute backend. Three co-located panels:
//   1. Spot Workers    — durable audit trail of on-demand quant spot workers:
//      what's running right now + for how long, plus a history of past workers
//      with why each one ended (idle / spot reclaim / manual deploy / crash).
//   2. Canary Outcomes — daily v2-parity + order-lifecycle canary history, the
//      promote-to-production evidence (match-streak gates the v2 cutover).
//   3. Compute Queue   — live view of what's queued / in-flight on the Celery
//      pipeline queues, with per-item withdraw for stale/duplicate messages.
//   0. Incidents (superusers only, wish #18) — DB restarts/outages, failed tasks,
//      workers killed mid-task, with whether each was emailed.
//
// Mobile-first, dark-default, institutional styling.
// ─────────────────────────────────────────────────────────────────────────
import React, { useState } from 'react';
import SpotWorkersPanel from './SpotWorkersPanel';
import ComputeQueuePanel from '../optimizations/ComputeQueuePanel';
import CanaryOutcomesPanel from './CanaryOutcomesPanel';
import OrphanGuardPanel from './OrphanGuardPanel';
import IncidentsPanel from './IncidentsPanel';
import { useAuth } from '../../../context/AuthContext';

export default function SystemPage() {
  const { user } = useAuth();
  const [toast, setToast] = useState(null);
  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2800); };

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-serif text-gray-900 dark:text-gray-100">System</h2>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          Quant compute backend — spot-worker audit trail, canary outcomes, and live compute queue.
        </p>
      </div>

      {user?.is_admin && <IncidentsPanel />}
      <SpotWorkersPanel />
      <OrphanGuardPanel />
      <CanaryOutcomesPanel />
      <ComputeQueuePanel showToast={showToast} />

      {toast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[60] px-4 py-2 rounded-lg bg-[#161b22] border border-brand-gold/40 text-brand-gold text-xs font-mono shadow-[0_8px_30px_rgba(201,169,110,0.18)] opt-bulk-in">
          {toast}
        </div>
      )}
    </div>
  );
}
